import { useRecoilValue } from 'recoil'

import { userUserRoleAtom } from 'atoms'
import useInnovaAxios from './useInnovaAxios'
import useInnovaAuth from './useInnovaAuth'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../queryKeys'

const useUserDatabaseAccess = (shouldFetch) => {
  const userRole = useRecoilValue(userUserRoleAtom)
  const { user, getDatabaseOrg, saveDatabaseOrg } = useInnovaAuth()

  const fetchDatabaseAccess = useInnovaAxios({
    url: '/user/getOrgDatabaseAccessList',
  })

  const { data: userDatabaseAccess } = useQuery({
    queryKey: [QUERY_KEYS.userDatabaseAccessKey],
    queryFn: async () => {
      if (!user || !user.name) return { userName: '', organizations: [] }

      let userChanged = false
      if (userDatabaseAccess?.userName !== user.name) {
        userChanged = true
      }
      if (!userChanged && Array.isArray(userDatabaseAccess?.organizations) && userDatabaseAccess.organizations.length > 0  && !shouldFetch) {
        return userDatabaseAccess
      }
      
      const res = await fetchDatabaseAccess({ params: { userName: user.name } })
      if (res?.error) throw new Error(res.error)
      if (!Array.isArray(res?.data)) return { userName: '', organizations: [] }
      return { userName: user.name, organizations: res.data.sort((a, b) => a.localeCompare(b)) }
    },
    enabled: !!user?.name,
    staleTime: Infinity,
  })

  const getUserDatabaseAccessList = () => {
    return Array.isArray(userDatabaseAccess?.organizations) ? userDatabaseAccess?.organizations : []
  }

  const hasMultiDbAccess = () => {
    return Array.isArray(userDatabaseAccess?.organizations) && userDatabaseAccess?.organizations.length > 1
  }

  const setAccessDatabase = (organization) => {
    if (!organization) return
    if (typeof organization !== 'string') return
    saveDatabaseOrg(organization)
  }

  const getCurrentDatabaseOrg = () => {
    let org = getDatabaseOrg()
    if (!org || typeof org !== 'string' || org === '') return userRole.organization
    return org
  }

  return { getUserDatabaseAccessList, hasMultiDbAccess, getCurrentDatabaseOrg, setAccessDatabase }
}

export default useUserDatabaseAccess
